<template>
    <div id="content" v-if="!loading">
      <popup v-show="hasPopup"
             :popup-type="getPopupType"
             :popup-action="getPopupAction"
             @popup-action="executePopupAction" />
      <form action="#">
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: 'advertisingProviderChannelGroups', params: { id: entity.id_advertising_provider} }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>

          <p class="buttons">
            <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
               @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
          </p>

          <h1>{{ entity.name }}</h1>
        </div>

        <div id="responsiveTabs" class="responsiveTabs r-tabs">
            <ul class="tabs r-tabs-nav">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'advertisingProviderChannelGroupDetailSettings'}"><a
                    @click.stop="openRoute('advertisingProviderChannelGroupDetailSettings')" v-translate>Vlastnosti</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'advertisingProviderChannelGroupDetailChannels'}"><a
                    @click.stop="openRoute('advertisingProviderChannelGroupDetailChannels')" v-translate>Kanály</a></li>
            </ul>

            <keep-alive>
                <router-view
                    :entity="entity"
                    :isEditable="$_updateActionAllowed"
                    @reloadEntity="getEntity"
                    @updateEntity="submitForm"
                    @deleteChannelGroup="deleteChannelGroup"
                />
            </keep-alive>

        </div>
      </form>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: 'AdvertisingProviderChannelGroupDetail',
    mixins: [
        detailActions,
    ],
    data() {
        return {
            entityName: 'advertisingProviderChannelGroup',
            moduleName: 'advertisingProviders',
            loading: true,
            prevRoute: null,
            updateFields: [
                'name',
                'time_with_no_advertisement_after_start_seconds',
                'skip_after_seconds',
                'osd_delay_seconds',
                'automatic_osd_showup',
                'skippable',
                'allow_skip_multiple_advertisement_blocks',
                'time_with_no_advertisement_after_start_seconds_nonlinear',
                'skip_after_seconds_nonlinear',
                'osd_delay_seconds_nonlinear',
                'automatic_osd_showup_nonlinear',
                'skippable_nonlinear',
                'allow_skip_multiple_advertisement_blocks_nonlinear',
            ],
        }
    },
    created(AdvertisingProviderChannelGroupService) {
        this.entityService = AdvertisingProviderChannelGroupService;
        this.createdInit()
    },
    beforeDestroy() {
        this.activateTab('settings')
    },
    methods: {
      executePopupAction(value) {
        if (value === true) {
          if (this.getPopupAction === 'delete') {
            this.deleteChannelGroup()
          }
        }
        this.hidePopup();
      },
      deleteChannelGroup() {
        this.deleteEntity(false, {
          path: 'advertisingProviderChannelGroups',
          params: { id: this.entity.id_advertising_provider }
        })
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/channelGroup/ChannelGroupDetail.vue